module.exports = __webpack_public_path__ + "img/9788952215512.30e40414.jpg";